import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';

import { UPC_SCAN } from '../icons';
import ScanModal from './ScanModal';
import { scan } from '../../platform';

/**
 * The camera on an input, as the RIGHTMOST member of its `Space.Compact`
 * affix group.
 *
 * That placement is the house rule, not a preference: docs/platform-standards
 * fixes actions rightmost in the group and passive text inside the input —
 * the measurement unit-picker's precedent. And the standards' §4 line
 * "values carry their actions" is about READ surfaces, where every value
 * action only ever LEAVES (open the map, dial the number). A scan is the
 * mirror image: it is an INPUT affordance and it WRITES. Keeping the two
 * distinct is why this lives beside the input rather than in the value's
 * action menu.
 *
 * WHEN THERE IS NO CAMERA, THERE IS NO BUTTON. A button that opens a modal
 * only to say "this browser will not give the page a camera" is worse than
 * its absence: the reader has already decided the feature is broken. The
 * check is cheap and synchronous (getUserMedia present, secure context); the
 * expensive, asynchronous half — is there a real BarcodeDetector backend —
 * happens inside the modal, where there is somewhere to say what happened.
 */
export default function ScanButton({
	formats = [],
	onDecode,
	disabled = false,
	title = 'Scan a code',
	label = 'Scan',
}) {
	const [open, setOpen] = useState(false);
	const { available } = scan.availability();
	if (!available) return null;

	return (
		<>
			<Tooltip title={label}>
				<Button
					type="default"
					size="large"
					disabled={disabled}
					icon={<UPC_SCAN size={16} />}
					aria-label={label}
					onClick={() => setOpen(true)}
				/>
			</Tooltip>
			<ScanModal
				open={open}
				title={title}
				formats={formats}
				onClose={() => setOpen(false)}
				onDecode={value => { setOpen(false); onDecode(value); }}
			/>
		</>
	);
}
